export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 to-primary-600 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">
              随时随地吃瓜
            </h2>
            <p className="text-primary-100 text-base leading-relaxed mb-6">
              51吃瓜官网在线全面适配移动端，无论您身在何处，打开手机就能第一时间吃到最新瓜料。收藏网址，吃瓜不等待！
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/20 text-white text-sm font-medium backdrop-blur-sm cursor-default">
                <i className="ri-smartphone-line"></i>
                <span className="whitespace-nowrap">手机浏览器访问</span>
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/20 text-white text-sm font-medium backdrop-blur-sm cursor-default">
                <i className="ri-bookmark-line"></i>
                <span className="whitespace-nowrap">添加到主屏幕</span>
              </span>
            </div>
          </div>
          <div className="w-48 h-48 md:w-56 md:h-56 flex-shrink-0">
            <div className="w-full h-full rounded-2xl bg-white/15 backdrop-blur-sm flex items-center justify-center border border-white/20">
              <div className="text-center">
                <i className="ri-smartphone-line text-6xl text-white/80"></i>
                <p className="text-white/70 text-xs mt-2 font-medium">吃瓜官网</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}